import React, { useEffect, useState, useRef, useContext } from "react";
import { useParams } from "react-router-dom";
import style from "./style.module.css";

import "./style.css";

import { ReactComponent as WhatsappIcon } from "../../assets/icons/whatsapp.svg";
import { ReactComponent as Downloadimg } from "../../assets/icons/download-br.svg";
import { ReactComponent as RightArrow } from "../../assets/icons/RightArrowwithoutbg.svg";
import { ReactComponent as BacktoTopIcon } from "../../assets/icons/backtotop.svg";
import { ReactComponent as RightIconCard } from "../../assets/icons/righticon.svg";
import { ReactComponent as LeadsAvtar } from "../../assets/leads_avtar.svg";
import { ReactComponent as RupeesIconYellow } from "../../assets/rupees_yellow.svg";
import { ReactComponent as OfferImg } from "../../assets/offers.svg";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calendar.svg";
import benifitsBg from "../../assets/benifits_bg.jpg";
import referBg from "../../assets/refer_bg.jpg";
import bannerImg from "../../assets/banner_detail.png";
import videoImg from "../../assets/video_img.png";
import { ReactComponent as ShareIcon } from "../../assets/icons/share.svg";
import { ReactComponent as PdfIcon } from "../../assets/plus_icon/pdf.svg";
import documnetimg from "../../assets/icons/documnet-bg.jpg";
import {
  addToProjectList,
  downloadAllMedia,
  getCRMProjectsDetail,
  getProjectDataForPlusApp,
  getProjectDetailsDummy,
  getProjectSpecifications,
  insertProjectRegisteration,
} from "../../services/public/public.service";
import moment from "moment";
import LightGalleryModal from "./LightGalleryModal";

import { useCallback } from "react";
import { toast } from "react-toastify";

import ContactModal from "../../components/Modals/ContactModal";
import AddYourListModal from "../../components/Modals/AddYourListModal";
import { useHistory } from "react-router-dom";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Video from "yet-another-react-lightbox/plugins/video";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { Link } from "react-router-dom";
import { getAuthRolePermissions } from "../../services/private/company.service";
import Consumer from "../../helpers/context";
import TooltipText from "../../components/Tooltip";
import { ReactComponent as PhoneIcon } from "../../assets/icons/Phone.svg";
import { ReactComponent as CheckIcon } from "../../assets/icons/CheckPrimary.svg";
import Slider from "react-slick";

import { ReactComponent as LeftSlideIcon } from "../../assets/icons/whiteLeftNav.svg";
import { ReactComponent as RightSlideIcon } from "../../assets/icons/whiteRightNav.svg";
import { ReactComponent as AvIcon } from "../../assets/av.svg";
import { ReactComponent as PicIcon } from "../../assets/pic.svg";
import { ReactComponent as UserIcon } from "../../assets/icons/userplus.svg";
import { ReactComponent as DownIcon } from "../../assets/icons/downIcon.svg";
import { ReactComponent as RupeeIcon } from "../../assets/icons/rupee-circle.svg";
import { ReactComponent as ArrowIcon } from "../../assets/icons/maximize.svg";
import NewLeadModal from "./Modal/NewLeadModal";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { Document, Page, pdfjs } from "react-pdf";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import LeadSubmitSuccess from "./Modal/LeadSubmitSuccess";
import LeadSubmitFail from "./Modal/LeadSubmitFail";
import ScheduleSiteVisitModal from "../Plus LeadManager/Modal/ScheduleSiteVisitModal";
import { ReactComponent as BlueCheckIcon } from "../../assets/plus_icon/Check icon.svg";
import { getInitials } from "../../helpers/helpers";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className="absolute -bottom-10 right-16 w-11 h-11 flex items-center justify-center  rounded-full bg-black/70 !z-[9] hover:bg-black cursor-pointer"
      onClick={onClick}
    >
      <LeftSlideIcon />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className="absolute -bottom-10 right-0 w-11 h-11 flex items-center justify-center rounded-full bg-black/70 z-9 hover:bg-black cursor-pointer"
      onClick={onClick}
    >
      <RightSlideIcon />
    </div>
  );
}

const offer = {
  dots: false,
  infinite: true,
  arrows: false,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: false,
  autoplay: true,
  variableWidth: true,
  // centerPadding: '60px',
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
};
var florplan = {
  dots: false,
  infinite: true,
  variableWidth: true,
  className: "pb-20",
  autoplay: true,
  // speed: 500,
  slidesToScroll: 1,

  // variableWidth: true,
  adaptiveHeight: true,
  nextArrow: <SamplePrevArrow />,
  prevArrow: <SampleNextArrow />,
  responsive: [
    {
      breakpoint: 1024,
      florplan: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      florplan: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 480,
      florplan: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
  ],
};

const showArea = (config) => {
  if (config.carpet_area) {
    return (
      <p className="m-0 flex justify-between items-center">
        <span className=" flex text-xs">
          {/* <BuildingIcon className='!w-4 !h-4 fill-darkblack-200 !mr-2' /> */}
        </span>
        <span className="text-sm font-medium text-textblack">
          {config?.carpet_area
            ? `${config?.carpet_area} ${config?.carpet_area_unit}`
            : "-"}
        </span>
      </p>
    );
  }
  if (config.super_area) {
    return (
      <p className="m-0 flex justify-between items-center">
        <span className=" flex text-xs">
          {/* <BuildingIcon className='!w-4 !h-4 fill-darkblack-200 !mr-2' /> */}
        </span>
        <span className="text-sm font-medium text-textblack">
          {config?.super_area
            ? `${config?.super_area} ${config?.super_area_unit}`
            : "-"}
        </span>
      </p>
    );
  }
};

const showAreaUnit = (config) => {
  if (config.carpet_area) {
    return "Carpet Area";
  }
  if (config.super_area) {
    return "Super Built-up Area";
  }
};

const ProjectDetail = () => {
  const [details, setDetails] = useState({});
  const [showLightModal, setShowLightModal] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [media, setMedia] = useState([]);
  // For export csv
  const [tempConfig, setTempConfig] = useState([]);
  const [tempPaymentPlan, setTempPaymentPlan] = useState([]);
  const [tempBankDetails, setTempBankDetails] = useState([]);
  const [tempAdditionalCost, setTempAdditionalCost] = useState([]);
  const [showAddToListModal, setShowAddToListModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [sectionId, setSectionId] = useState();
  const [selectdImg, setSelectdImg] = useState();
  const [thumbnail, setThumbnail] = useState("");
  const [videos, setVideos] = useState([]);
  const [projectPermission, setProjectPermission] = useState();
  const [transaction, setTransaction] = useState();
  const [property, setProperty] = useState();
  const [inventory, setInventory] = useState();
  const [specifications, setSpecifications] = useState([]);
  const [showAmenityContent, setShowAmenityContent] = useState(false);
  const [showFloorContent, setShowFloorContent] = useState(false);
  const [showHighlightContent, setShowHighlightContent] = useState(false);
  const [showLocationContent, setShowLocationContent] = useState(false);
  const [showSpecificationContent, setShowSpecificationContent] =
    useState(false);
  const [showAboutContent, setShowAboutContent] = useState(false);
  const [viewAllProjectContent, setViewAllProjectContent] = useState(false);
  const [viewAll, setViewAll] = useState(false);
  const [showSiteVisitModal, setShowSitevisitModal] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfWidth, setPdfWidth] = useState(800);
  const [pageFullWidth, setPageFullWidth] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [showLeadSuccessModal, setShowLeadSuccessModal] = useState(false);
  const [brochure, setBrochure] = useState();
  const [showTaggingDescription, setShowTaggingDescription] = useState(false);
  const [showAllAmenities, setShowAllAmenities] = useState(false);
  const [showAllSpecification, setShowAllSpecification] = useState(false);
  const [showAllAdvantage, setShowAllAdvantage] = useState(false);

  const [isActive, setIsActive] = useState(false);
  const scrollDivRef = useRef(null);

  useEffect(() => {
    const scrollDiv = scrollDivRef.current;
    if (!scrollDiv) return;

    const handleScroll = () => {
      const scrollTop = scrollDiv.scrollTop;
      if (scrollTop > 610) {
        // Adjust the value as needed
        setIsActive(true);
      } else {
        setIsActive(false);
      }
    };

    scrollDiv.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      scrollDiv.removeEventListener("scroll", handleScroll);
    };
  }, [scrollDivRef.current]); // Depend on scrollDivRef.current to rerun the effect if the ref changes

  const observer = useRef(null);

  let { allowedPermissions, isRolesModule, userProfile } = useContext(Consumer);

  const { uuid } = useParams();
  const divRef = useRef(null);
  const history = useHistory();

  const handleScroll = (e) => {
    const scrollPosition = divRef.current.scrollTop;
    setShowButton(scrollPosition > 500);
  };

  const styles = {
    backgroundImage: `url(${benifitsBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepet: "no-repet",
  };

  const getDetails = async () => {
    try {
      const res = await getProjectDetailsDummy(
        "kolte-patil-city-vista-kharadi-pune"
      );
      if (res.data.status === 200) {
        console.log(res.data.data);
        setDetails(res.data.data);
      }
    } catch (err) {
      console.log({ err });
      if (err?.response?.status === 404) {
        // navigate('/404')
      }
    }
  };

  const getProjectDetails = async () => {
    // const res = await getCRMProjectsDetail(uuid);
    const res = await getProjectDataForPlusApp(uuid);
    if (res.data.status === 200) {
      console.log(res.data.data, "details");
      let media = [];
      let doc = [];
      let video = [];
      res.data.data.media.forEach((item) => {
        if (
          ["jpg", "png", "gif", "svg", "jpeg"].includes(
            item.file_name.split(".").pop()
          )
        ) {
          media.push(item);
        } else if (
          ["mp4", "mp3", "mkv"].includes(item.file_name.split(".").pop()) ||
          item.type === "youtube_video"
        ) {
          video.push(item);
        } else {
          doc.push(item);
        }
      });
      res.data.data.media.forEach((item) => {
        if (item.media_name === "Brochure") {
          setBrochure(item);
        }
      });

      console.log(media, "mediamedia");
      const cover = media.find((item) => item.is_cover);
      setInventory(res.data.data.inventory_type);
      setProperty(res.data.data.property_type);
      setTransaction(res.data.data.transaction_type);
      setThumbnail(cover?.url || media[0]?.url);
      setMedia(media);
      setVideos(video);
      setDocuments(doc);
      // const docs = res.data.data.media.filter(item => item.type === 'application/pdf');
      setDetails(res.data.data);
      // setDocuments(docs)
    }
  };

  const getUsersAuthRolePermissions = () => {
    getAuthRolePermissions().then((res) => {
      res.data.data.map((role) => {
        if (role.module === "projects") {
          setProjectPermission(role.permissions);
        }
      });
    });
  };

  const getSpecifications = async () => {
    const res = await getProjectSpecifications(uuid);
    if (res.data.status === 200) {
      setSpecifications(res.data.data);
    }
  };

  useEffect(() => {
    getProjectDetails();
    // getProjectDetails();
    getUsersAuthRolePermissions();
    // getSpecifications();
    // getDetails()
  }, []);

  const handleAddToList = useCallback(async () => {
    const res = await addToProjectList(uuid);
    if (res.data.status === 200) {
      toast.success(res.data.message);
      getProjectDetails();
    }
  }, []);

  const handleContact = useCallback(async () => {
    const res = await insertProjectRegisteration(uuid);
    if (res.data.status === 200) {
      toast.success(res.data.message);
      // setShowContactModal(false);
      // getProjectDetails()
    }
  }, []);

  const handleScrollEvent = () => {
    var header = document.getElementById("detail_page");
    var sticky = header.offsetTop;
    const elem = header.getBoundingClientRect();
    if (elem.y < 1) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  useEffect(() => {
    const homeElement = document.getElementById("home");
    if (homeElement) {
      homeElement.scrollIntoView({ behavior: "smooth" });
    }

    window.addEventListener("scroll", handleScrollEvent, true);

    //create new instance and pass a callback function
    observer.current = new IntersectionObserver((entries) => {
      const visibleSection = entries.find(
        (entry) => entry.isIntersecting
      )?.target;
      //Update state with the visible section ID
      console.log(visibleSection, "visibleSection");
      if (visibleSection) {
        setActiveSection(visibleSection.id);
      }
    });

    //Get custom attribute data-section from all sections
    const sections = document.querySelectorAll("[data-section]");

    sections.forEach((section) => {
      observer.current.observe(section);
    });

    return () => {
      window.removeEventListener("scroll", handleScrollEvent, true);

      sections.forEach((section) => {
        observer.current.unobserve(section);
      });
    };
  }, []);

  const scrollToSection = (sectionId) => {
    // let sectionRef = useRef(null);
    let sectionElement = document.getElementById(sectionId);

    if (sectionElement) {
      // sectionRef.current = sectionElement;
      sectionElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  console.log(details, "details details", userProfile);
  if (Object.keys(details).length === 0) {
    return null;
  }

  return (
    <div
      ref={scrollDivRef}
      className={`${style.projectdetailPage} projectdetailPage d-flex flex-column w-100 h-100 overflow-auto`}
    >
      <div className={`${style.sticky_top} d-flex flex-col gap-y-1 border-0`}>
        <div>
          <nav aria-label="breadcrumb" className="inner-page-breadcrumb">
            <ul className="d-flex align-items-center justify-content-start flex-row inter m-0">
              <li>
                <Link to="/projects">Projects </Link>
              </li>
              <li className="flex items-center">
                <RightArrow />
                <span className={`${style.msingleline} w-[360px] truncate`}>
                  {details?.name}
                </span>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <div
        className="d-flex flex-fill flex-column  relative"
        ref={divRef}
        onScroll={handleScroll}
        id="detail_page"
        data-spy="scroll"
        data-target="#navbar-example"
      >
        {/* <div className={`${style.Detailbanner}  d-flex align-items-start`} style={styles} id='home'>
                    <div className='mt-24 d-md-none d-none align-items-start gap-14 justify-content-between w-100 px-24'>
                        <a href='/projects' className={`${style.backbtn}`}><BackIcon /></a>
                    </div>
                </div> */}
        {/* <div className={`${style.bannerTags}`}><TradingIcon />Trending</div>
                    <div className={`${style.bannerTags} text-white`}><ClockIcon />13 People Contacted Today</div> */}
        <div className={`h-[400px] !mb-10 !px-5`}>
          <div className="flex h-full">
            <div className="w-full rounded-xl h-full relative">
              <img
                src={thumbnail}
                className="h-full w-full rounded-xl object-cover"
              />
              <button
                className="flex absolute right-4 bottom-4 text-black font-semibold bg-[#FFFFFFCC] hover:bg-white rounded-lg !p-2"
                onClick={() => setShowLightModal(true)}
              >
                <span className="mr-2">
                  <PicIcon className="stroke-black" />
                </span>
                Show all photos
              </button>
            </div>
            {/* <div className='w-1/3'>
                            <div className='w-full h-[186px] rounded-lg relative'>
                                <img src={videoImg} className='w-full h-full rounded-xl' />
                                <p className='m-0 text-white absolute left-4 bottom-4 font-semibold'>
                                    Videos
                                </p>
                                <button className='flex absolute right-4 bottom-4 text-black font-semibold bg-[#FFFFFFCC] rounded-lg !p-2' >
                                    <span className='mr-2'>
                                        <PicIcon className='stroke-black' />
                                    </span>
                                    Show all Video
                                </button>
                            </div>
                            <div className='w-full h-[186px] !mt-4 relative'>
                                <img src={media[0].url} className='w-full h-full rounded-xl' />

                                <button className='flex absolute right-4 bottom-4 text-black font-semibold bg-[#FFFFFFCC] rounded-lg !p-2'
                                    onClick={() => setShowLightModal(true)}
                                >
                                    <span className='mr-2'>
                                        <PicIcon className='stroke-black' />
                                    </span>
                                    Show all photos
                                </button>
                            </div>
                        </div> */}
          </div>
        </div>
        <div className="!px-6">
          <div className="flex relative">
            <div className="flex ">
              <div className="w-24 h-24 !border border-grayLight rounded-xl !mr-4 overflow-hidden">
                <img
                  src={details?.logo}
                  alt=""
                  className="rounded-xl w-full h-full  object-cover "
                />
              </div>
              <div>
                <div className="flex !gap-6 items-center">
                  <h3 className="text-2xl capitalize m-0 text-textblack font-semibold !mb-1">
                    {details?.name}
                  </h3>
                  <div>
                    <div className="!py-1 !px-2 text-blue-900 font-medium bg-blueHighlight rounded-full  w-28 text-sm text-center">
                      New Launch
                    </div>
                  </div>
                </div>
                <p className="m-0 font-semibold text-base text-textblack">
                  By&nbsp;
                  <span className="text-blue-900">
                    {details.builder_info[0]?.builder_name}
                  </span>
                </p>
                <p className="text-black700 !mt-2 mb-0 text-base">
                  {details?.google_address}
                </p>
              </div>
            </div>
          </div>
          {/* <div className={`d-flex w-full align-items-center justify-content-between !mt-10 border-b ${isSticky ? 'sticky-navbar' : ''}`} id='detail_navbar'> */}
        </div>
        <div className="mt-6">
          <div
            className={
              isActive
                ? "shadow-bottomshadow d-flex w-full align-items-center justify-content-between sticky top-0 z-[999] bg-white !px-5 duration-75	transition-all	"
                : "d-flex w-full align-items-center justify-content-between sticky top-0 z-[999] bg-white !px-5 duration-75	transition-all	"
            }
            //  className=''
            id=" detail_navbar"
          >
            <nav id="navbar-example2" className={`navbar px-0 `}>
              <ul className="nav nav-pills gap-x-32 flex-nowrap">
                <li className="nav-item">
                  <button
                    className={`nav-link !py-1.5 font-medium !text-sm  !px-3 hover:!text-white hover:!bg-black hover:!rounded-full ${
                      activeSection === "overview"
                        ? "!text-white !bg-black !rounded-full"
                        : "text-black700"
                    }`}
                  >
                    Overview
                  </button>
                </li>
                <li className="nav-item">
                  <button className="nav-link !py-1.5 font-medium !text-sm  !px-3 text-black700 hover:!text-white hover:!bg-black hover:!rounded-full">
                    Details
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link !py-1.5 font-medium !text-sm  !px-3 hover:!text-white hover:!bg-black hover:!rounded-full ${
                      activeSection === "brokerage"
                        ? "!text-white !bg-black !rounded-full"
                        : "text-black700"
                    }`}
                  >
                    Brokerage
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link !py-1.5 font-medium !text-sm  !px-3 hover:!text-white hover:!bg-black hover:!rounded-full ${
                      activeSection === "floorPlan"
                        ? "!text-white !bg-black !rounded-full"
                        : "text-black700"
                    }`}
                  >
                    {" "}
                    Floor Plan
                  </button>
                </li>
              </ul>
            </nav>
          </div>
          <div className="w-full flex !mt-10">
            <div className="xl:w-[calc(100%-387px)] w-full !pl-5 pr-8">
              <div className="" id="overview" data-section>
                <h3 className="text-2xl md:!mb-6 !mb-3 capitalize text-textblack font-semibold">
                  {details?.name}
                </h3>
                <div className="flex flex-col">
                  {!viewAllProjectContent && (
                    <div
                      className="!mb-0 [&>*]:!text-[#647087]"
                      dangerouslySetInnerHTML={{
                        __html: details?.description?.slice(0, 400),
                      }}
                    ></div>
                  )}
                  {viewAllProjectContent && (
                    <div
                      className="!mb-0 [&>*]:!text-[#647087]"
                      dangerouslySetInnerHTML={{ __html: details?.description }}
                    ></div>
                  )}
                  {details?.description?.length > 400 && (
                    <a
                      className="text-blue-900 cursor-pointer hover:bg-clip-text hover:text-transparent hover:bg-gradient-to-r from-[#684EFB] to-[#2064FA]"
                      onClick={() =>
                        setViewAllProjectContent(!viewAllProjectContent)
                      }
                    >
                      {!viewAllProjectContent ? "Read more" : "Read less"}
                    </a>
                  )}
                </div>
              </div>
              <div className="sm:!mt-10 mt-12 ">
                <div className="border rounded-xl shadow-cardshadow !px-4 !py-2">
                  {/* <div className='p-3 justify-between flex  bg-[#1A1A1A05]'>
                                        <div className=" text-black700 text-sm w-1/3">Price </div>
                                        <div className="w-2/3 text-sm text-gray700 text-end ">Brokerage</div>
                                    </div> */}
                  <div className="!py-2.5 border-b flex justify-between ">
                    <div className="5/12">
                      <div className=" text-black700 text-sm w-1/3">Price </div>
                    </div>
                    <div className="w-7/12">
                      <div className="flex flex-wrap justify-end !gap-x-4">
                        {details.configurations.map((c, index) => (
                          <div className="text-sm w-max text-gray700 text-end flex items-center">
                            ₹&nbsp;{c.price_range} {c.area_range}{" "}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="!py-2.5 border-b justify-between flex">
                    <div className=" text-black700 text-sm w-1/3">
                      Project Size
                    </div>
                    <div className="w-2/3 text-sm text-gray700 text-end">
                      {details?.size
                        ? `${details?.size} ${details?.size_unit}`
                        : "-"}
                    </div>
                  </div>
                  <div className="!py-2.5 border-b justify-between flex">
                    <div className=" text-black700 text-sm w-1/3">
                      Possession{" "}
                    </div>
                    <div className="w-2/3 text-sm text-gray700 text-end">
                      {moment(details?.possession_date).format("MMM Do YYYY")}
                    </div>
                  </div>
                  <div className="!py-2.5 border-b justify-between flex">
                    <div className="5/12">
                      <div className=" text-black700 text-sm w-1/3">
                        Configuration{" "}
                      </div>
                    </div>

                    <div className="w-7/12">
                      <div className="flex flex-wrap justify-end !gap-x-4">
                        {details.configurations.map((c, index) => (
                          <div className="text-sm w-max text-gray700 text-end flex items-center">
                            {c.unit_configuration}{" "}
                            <div className="!h-1 !w-1 rounded-full !mx-1  bg-black700"></div>{" "}
                            {showArea(c)}{" "}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="!py-2.5 justify-between flex">
                    <div className="w-6/12">
                      <div className=" text-black700 text-sm w-1/3">
                        Payment Plans{" "}
                      </div>
                    </div>
                    <div className="w-6/12">
                      <div className=" bg-clip-text text-sm text-transparent bg-gradient-to-r from-[#684EFB] to-[#2064FA]  font-semibold text-end">
                        {details?.payment_plans
                          ? details?.payment_plans[0]?.name
                          : "-"}
                        &nbsp;
                        <span>View more</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="border-t !mt-6 !mb-5"></div>
              {brochure && (
                <div className="relative">
                  <div className="flex items-center justify-between md:!mb-6 !mb-3">
                    <h3 className="text-2xl font-semibold text-textblack flex items-center">
                      <span className="!mr-2">
                        <PdfIcon />
                      </span>
                      Project Brochure
                    </h3>
                    <div
                      className="border rounded-lg !p-2.5 hover:bg-black/10 cursor-pointer"
                      onClick={() => {
                        window.open(
                          `https://api.whatsapp.com/send?text=${brochure.url}`
                        );
                      }}
                    >
                      <ShareIcon />
                    </div>
                  </div>
                  <div className="border rounded-xl flex flex-col overflow-hidden shadow-cardshadow">
                    <div className="!h-[336px] overflow-auto items-start flex justify-center relative">
                      <Document
                        file={brochure.url}
                        onLoadSuccess={onDocumentLoadSuccess}
                        loading={"Document loading..."}
                      >
                        <Page pageNumber={pageNumber} width={pdfWidth} />
                      </Document>
                    </div>
                    <div className="d-flex align-items-center justify-content-center flex-row bg-black/80 !text-white">
                      <p className="mb-0">
                        <span className="mr4">Page</span>{" "}
                        {pageNumber || (numPages ? 1 : "--")} <span>/</span>{" "}
                        {numPages || "--"}
                      </p>
                      <div className="d-flex align-items-center jutify-content-center flex-row plush-minus !gap-4">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip
                              id="button-tooltip"
                              className="sidebar-tooltip"
                            >
                              <div className="info-msg">
                                {/* <h4>Total Leads</h4> */}
                                <p className="d-flex fz18">Zoom out</p>
                              </div>
                            </Tooltip>
                          }
                        >
                          <button onClick={() => setPdfWidth(pdfWidth - 50)}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                            >
                              <rect
                                width="32"
                                height="32"
                                rx="4"
                                fill="#575761"
                              />
                              <path d="M10 15H22.5V17.5H10V15Z" fill="white" />
                            </svg>
                          </button>
                        </OverlayTrigger>

                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip
                              id="button-tooltip"
                              className="sidebar-tooltip"
                            >
                              <div className="info-msg">
                                {/* <h4>Total Leads</h4> */}
                                <p className="d-flex fz18">Zoom in</p>
                              </div>
                            </Tooltip>
                          }
                        >
                          <button
                            onClick={() => setPdfWidth(pdfWidth + 50)}
                            className=""
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                            >
                              <rect
                                width="32"
                                height="32"
                                rx="4"
                                fill="#575761"
                              />
                              <path
                                d="M17.5 15V10H15V15H10V17.5H15V22.5H17.5V17.5H22.5V15H17.5Z"
                                fill="white"
                              />
                            </svg>
                          </button>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="prev !absolute left-10 top-[45%] bg-black/70 w-11 h-11 rounded-full hover:bg-black z-10 inline-flex items-center justify-center disabled:opacity-0"
                      disabled={pageNumber <= 1}
                      onClick={previousPage}
                    >
                      <LeftSlideIcon />
                    </button>
                    <button
                      className="next !absolute right-10 top-[45%] bg-black/70 w-11 h-11 rounded-full hover:bg-black z-10 inline-flex items-center justify-center disabled:opacity-0"
                      type="button"
                      disabled={pageNumber >= numPages}
                      onClick={nextPage}
                    >
                      <RightSlideIcon className="" />
                    </button>
                  </div>
                  <div className="!mt-6">
                    <button
                      className="flex border rounded-lg !p-2.5 text-black800 font-semibold text-base hover:bg-black/10"
                      onClick={() => {
                        const link = document.createElement("a");
                        link.href = brochure.url;
                        link.download = `${brochure.name}`;
                        link.click();
                      }}
                    >
                      <span className="!mr-2">
                        <Downloadimg />
                      </span>
                      Download Brochure
                    </button>
                  </div>
                </div>
              )}
              <div className="h-px bg-grayLight w-full  !mt-5"></div>
              {details?.tagging_description && (
                <div className="sm:!mt-10 mt-12">
                  <div className="flex items-center justify-between sm:!mb-6 !mb-3">
                    <div className="text-2xl font-semibold text-textblack ">
                      Tagging Validity
                    </div>
                    <div className="text-xs bg-gradient-to-r from-[#684EFB]/10 to-[#2064FA]/10  !py-1.5 px-2.5 font-bold rounded-3xl ">
                      <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#684EFB] to-[#2064FA] ">
                        {details.tagging_validity}{" "}
                        {details.tagging_validity_unit}
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col">
                    {!showTaggingDescription && (
                      <div
                        className="!mb-0 [&>*]:!text-[#647087]"
                        dangerouslySetInnerHTML={{
                          __html: details?.tagging_description?.slice(0, 400),
                        }}
                      ></div>
                    )}
                    {showTaggingDescription && (
                      <div
                        className="!mb-0 [&>*]:!text-[#647087]"
                        dangerouslySetInnerHTML={{
                          __html: details?.tagging_description,
                        }}
                      ></div>
                    )}
                    {details?.tagging_description?.length > 400 && (
                      <a
                        className="text-blue-900 cursor-pointer"
                        onClick={() =>
                          setShowTaggingDescription(!showTaggingDescription)
                        }
                      >
                        {!showTaggingDescription ? "Read More" : "Read Less"}
                      </a>
                    )}
                  </div>
                </div>
              )}
              {details?.brokerage?.length > 0 && (
                <div className="sm:!mt-10 mt-12" data-section id="brokerage">
                  <div className="text-2xl font-semibold text-textblack sm:!mb-6 !mb-3">
                    Brokerage Slabs
                  </div>
                  <div className="!border rounded-lg border-grayLight">
                    <div className="border-b p-3 flex bg-[#1A1A1A05]">
                      <div className="w-6/12">
                        <div className="font-medium text-textblack text-sm w-1/3">
                          Booking{" "}
                        </div>
                      </div>
                      <div className="w-6/12">
                        <div className="font-medium text-sm text-textblack">
                          Brokerage
                        </div>
                      </div>
                    </div>
                    {details?.brokerage?.map((brokerage, index) => (
                      <div className="border-b p-3 flex" key={brokerage.uuid}>
                        <div className="w-6/12">
                          <div className="font-normal text-textblack text-sm w-1/3 flex items-center ">
                            {brokerage.min_value}-{brokerage.max_value}
                          </div>
                        </div>
                        <div className="w-6/12">
                          <div className="text-sm text-textblack flex items-center font-semibold !gap-2">
                            <span className="!w-4 grow-0 shrink-0 basis-4">
                              <BlueCheckIcon className="w-4" />
                            </span>
                            {brokerage.brokerage_percentage} %
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="sm:!mt-10 mt-12" data-section id="floorPlan">
                <div className="text-2xl font-semibold text-textblack sm:!mb-6 !mb-3">
                  Floor Plan & Pricing
                </div>
                {/* <div className="" dangerouslySetInnerHTML={{ __html: details?.descriptions?.floor_plan_description }}></div> */}
                <div className="flex flex-col">
                  {!showFloorContent && (
                    <div
                      className="!mb-0 [&>*]:!text-[#647087]"
                      dangerouslySetInnerHTML={{
                        __html:
                          details?.descriptions?.floor_plan_description?.slice(
                            0,
                            400
                          ),
                      }}
                    ></div>
                  )}
                  {showFloorContent && (
                    <div
                      className="!mb-0 [&>*]:!text-[#647087]"
                      dangerouslySetInnerHTML={{
                        __html: details?.descriptions?.floor_plan_description,
                      }}
                    ></div>
                  )}
                  {details?.descriptions?.floor_plan_description?.length >
                    400 && (
                    <a
                      className="text-blue-900 cursor-pointer hover:bg-clip-text text-transparent bg-gradient-to-r from-[#684EFB] to-[#2064FA] "
                      onClick={() => setShowFloorContent(!showFloorContent)}
                    >
                      {!showFloorContent ? "Read More" : "Read Less"}
                    </a>
                  )}
                </div>

                {/* <div className='flex gap-x-3  mt-6'>
                                    <button className="inline-flex focus:outline-0 !border !border-[#FDDB1F] rounded-lg text-blue-gray font-medium text-sm !py-2 !px-4 bg-[#E6F750]/10 min-w-[96px] items-center justify-center">All</button>
                                    <button className="inline-flex focus:outline-0 !border !border-grayLight rounded-lg text-blue-gray font-medium text-sm !py-2 !px-4 item-center">4 BHK</button>
                                    <button className="inline-flex focus:outline-0 !border !border-grayLight rounded-lg text-blue-gray font-medium text-sm !py-2 !px-4 item-center">3 BHK</button>
                                </div> */}
                {details?.configurations?.length < 3 && (
                  <div className="mt-6 flex justify-start items-center">
                    {details?.configurations.map((config, index) => (
                      <div className="" key={`${config.uuid}`}>
                        <div className="!border !border-grayLight rounded-xl shadow-cardshadow w-[343px] !p-3 md:!mr-6 !mr-4 bg-white">
                          <div className="flex">
                            <div className="!mr-3">
                              <p className="text-lg font-bold !mb-2.5 flex items-center text-black">
                                <span className="mr-2.5">
                                  <RupeeIcon />
                                </span>
                                {config?.price_range || "-"}
                              </p>
                              <p className="text-sm mb-2.5 text-textblack font-semibold flex gap-x-2.5">
                                <ArrowIcon />
                                {/* {config?.area_range || '-'} */}
                                {showArea(config)}
                              </p>
                              <div className="!border !border-[#CFD5DE] rounded-lg !px-2 text-blue-gray text-xs font-medium py-1">
                                <span>
                                  {showAreaUnit(config)} |{" "}
                                  {config?.unit_configuration}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="rounded-lg !mt-4 h-[168px] w-full">
                            <img
                              src={config?.unit_plan_image}
                              alt={config?.unit_plan_image_alt_tag}
                              className="h-full w-full object-contain"
                            />
                          </div>
                          {/* <div className="!mt-3 bg-blueHighlight rounded-lg p-2 flex item-center justify-between cursor-pointer"
                                                            onClick={() => setShowContactModal(true)}
                                                        >
                                                            <span className="text-base font-medium text-blue-900">Request a Call Back</span>
                                                            <div ><PhoneIcon className='stroke-primary ' /></div>
                                                        </div> */}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {details?.configurations?.length > 2 && (
                  <div className="mt-6">
                    <Slider {...florplan}>
                      {details?.configurations.map((config, index) => (
                        <div className="" key={`${config.uuid}`}>
                          <div className="!border !border-grayLight/60 rounded-[10px] shadow-cardshadow w-[343px] !p-3 md:!mr-6 !mr-4 bg-white !my-3">
                            <div className="flex">
                              <div className="!mr-3">
                                <p className="text-lg font-bold !mb-2.5 flex items-center text-black">
                                  <span className="mr-2.5">
                                    <RupeeIcon />
                                  </span>
                                  {config?.price_range || "-"}
                                </p>
                                <p className="text-sm mb-2.5 text-textblack font-semibold flex gap-x-2.5">
                                  <ArrowIcon />
                                  {showArea(config)}
                                </p>
                                <div className="!border !border-[#CFD5DE] rounded-lg !px-2 text-blue-gray text-xs font-medium py-1">
                                  <span>
                                    {showAreaUnit(config)} |{" "}
                                    {config?.unit_configuration}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="rounded-lg !mt-4 h-[168px] w-full">
                              <img
                                src={config?.unit_plan_image}
                                alt={config?.unit_plan_image_alt_tag}
                                className="h-full w-full object-contain"
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                )}
              </div>

              <div className="sm:!mt-20 !mt-20" id="amenities">
                <h3 className="sm:!mb-6 !mb-3 text-2xl font-semibold text-textblack">
                  Amenities
                </h3>
                {/* {details?.project?.amenities_description && <div className="" dangerouslySetInnerHTML={{ __html: details?.project?.amenities_description }}></div>} */}
                {details?.amenities_description && (
                  <div className="flex flex-col">
                    {!showAmenityContent && (
                      <div
                        className="!mb-0 [&>*]:!text-[#647087]"
                        dangerouslySetInnerHTML={{
                          __html: details?.amenities_description?.slice(0, 400),
                        }}
                      ></div>
                    )}
                    {showAmenityContent && (
                      <div
                        className="!mb-0 [&>*]:!text-[#647087]"
                        dangerouslySetInnerHTML={{
                          __html: details?.amenities_description,
                        }}
                      ></div>
                    )}
                    {details?.amenities_description?.length > 400 && (
                      <a
                        className="text-blue-900 cursor-pointer hover:bg-clip-text hover:text-transparent hover:bg-gradient-to-r from-[#684EFB] to-[#2064FA]"
                        onClick={() =>
                          setShowAmenityContent(!showAmenityContent)
                        }
                      >
                        {!showAmenityContent ? "Read More" : "Read Less"}
                      </a>
                    )}
                  </div>
                )}
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5  !mt-5 gap-6 max-h-[400px] pb-4 pr-2 overflow-auto">
                  {!showAllAmenities &&
                    details?.amenities?.length > 0 &&
                    details?.amenities.slice(0, 5).map((item, index) => (
                      <div className="w-[40]  h-24 !border !border-grayLight !p-2 rounded-lg flex flex-col items-center justify-center bg-white text-center shadow-boxshadow">
                        {/* <div className="w-6 h-6 bg-black400 mb-6"></div> */}
                        <div className="text-black font-medium">{item}</div>
                      </div>
                    ))}
                  {showAllAmenities &&
                    details?.amenities?.length > 0 &&
                    details?.amenities.map((item, index) => (
                      <div className=" w-[40]  h-24 !border !border-grayLight !p-2 rounded-lg flex flex-col items-center justify-center bg-white text-center shadow-boxshadow">
                        {/* <div className="w-6 h-6 bg-black400 mb-6"></div> */}
                        <div className="text-black font-medium">{item}</div>
                      </div>
                    ))}
                </div>

                <div className="!mt-6 flex items-center">
                  <div className="w-6/12">
                    {details?.amenities?.length > 5 && (
                      <>
                        {!showAllAmenities && (
                          <div className="flex items-center">
                            <button
                              className="text-blue-900 font-semibold hover:bg-clip-text hover:text-transparent hover:bg-gradient-to-r from-[#684EFB] to-[#2064FA]"
                              onClick={() => setShowAllAmenities(true)}
                            >
                              Show all {details?.amenities?.length} Amenities
                            </button>
                          </div>
                        )}
                        {showAllAmenities && (
                          <div className="flex items-center">
                            <button
                              className="text-blue-900 font-semibold hover:bg-clip-text hover:text-transparent hover:bg-gradient-to-r from-[#684EFB] to-[#2064FA]"
                              onClick={() => setShowAllAmenities(false)}
                            >
                              Show less
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  <div className="w-6/12">
                    <button
                      className="ml-auto bg-[#684EFB] text-white text-base rounded-lg w-max !px-4 text-center font-semibold !py-2 flex items-center justify-center shadow-sm	shadow-[#101828]/5 bg-gradient-to-r from-[#684EFB] to-[#2064FA] hover:from-[#2064FA] hover:to-[#3B37F5]"
                      onClick={() => setShowSitevisitModal(true)}
                    >
                      <span className="mr-2">
                        <UserIcon className=" stroke-white " />
                      </span>
                      Schedule Site Visit
                    </button>
                  </div>
                </div>
                {/* <div
                                className="w-32 h-24 !border !border-grayLight !p-2 rounded-lg flex flex-col items-center justify-center">
                                <div>logo</div>
                                <div>Club house</div>

                            </div> */}
              </div>
              <div className="sm:!mt-10 !mt-12">
                <h3 className="md:!mb-6 !mb-3 text-2xl font-semibold text-textblack">
                  Location Advantages
                </h3>
                {/* <div className="" dangerouslySetInnerHTML={{ __html: details?.descriptions?.location_advantage_description }}></div> */}
                <div className="flex flex-col">
                  {!showLocationContent && (
                    <div
                      className="!mb-0 [&>*]:!text-[#647087]"
                      dangerouslySetInnerHTML={{
                        __html:
                          details?.descriptions?.location_advantage_description?.slice(
                            0,
                            400
                          ),
                      }}
                    ></div>
                  )}
                  {showLocationContent && (
                    <div
                      className="!mb-0 [&>*]:!text-[#647087]"
                      dangerouslySetInnerHTML={{
                        __html:
                          details?.descriptions?.location_advantage_description,
                      }}
                    ></div>
                  )}
                  {details?.descriptions?.location_advantage_description
                    ?.length > 400 && (
                    <a
                      className="text-blue-900 cursor-pointer hover:bg-clip-text hover:text-transparent hover:bg-gradient-to-r from-[#684EFB] to-[#2064FA]"
                      onClick={() =>
                        setShowLocationContent(!showLocationContent)
                      }
                    >
                      {!showLocationContent ? "Read More" : "Read Less"}
                    </a>
                  )}
                </div>
                <div className="mt-6">
                  <div className="sm:flex">
                    <ul className="!mr-4 sm:w-1/2 max-h-[300px] overflow-y-auto">
                      {!showAllAdvantage &&
                        details?.location_advantage?.length > 0 &&
                        details?.location_advantage
                          .slice(0, 4)
                          .map((adv, index) => (
                            <li className="!mt-4 flex " key={`${adv.uuid}`}>
                              <span className="!mr-2 w-8 h-8 grow-0 shrink-0 basic-8">
                                <CheckIcon />
                              </span>

                              <div>
                                <p className="m-0 text-black mb-0 font-medium">
                                  {adv.title}
                                </p>
                                <span className="text-xs">
                                  {adv.distance_from_project} Km
                                </span>
                              </div>
                            </li>
                          ))}
                      {showAllAdvantage &&
                        details?.location_advantage?.length > 0 &&
                        details?.location_advantage.map((adv, index) => (
                          <li className="!mt-4 flex " key={`${adv.uuid}`}>
                            <span className="!mr-2 w-8 h-8 grow-0 shrink-0 basic-8">
                              <CheckIcon />
                            </span>

                            <div>
                              <p className="m-0 text-black mb-0 font-medium">
                                {adv.title}
                              </p>
                              <span className="text-xs">
                                {adv.distance_from_project} Km
                              </span>
                            </div>
                          </li>
                        ))}
                    </ul>

                    <div className="sm:w-1/2">
                      <div className="border border-grayLight rounded-lg overflow-hidden">
                        <iframe
                          src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDRuni-c1oJBFaF8ahTxlxPmYyCmRRtclw&q=${details?.project?.google_address}`}
                          width="100%"
                          height="300"
                          allowFullScreen=""
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                          className="border-0"
                        ></iframe>
                      </div>
                      <p className="mt-2 text-sm text-[#696974] mb-0 font-sm font-medium">
                        Google Maps
                      </p>
                    </div>
                  </div>
                  {details?.location_advantage?.length > 4 && (
                    <>
                      {!showAllAdvantage && (
                        <div className="!mt-2">
                          <button
                            className="text-blue-900 font-semibold hover:bg-clip-text hover:text-transparent hover:bg-gradient-to-r from-[#684EFB] to-[#2064FA]"
                            onClick={() => setShowAllAdvantage(true)}
                          >
                            Show all {details?.location_advantage?.length}{" "}
                            Advantage
                          </button>
                        </div>
                      )}
                      {showAllAdvantage && (
                        <div className="!mt-2">
                          <button
                            className="text-blue-900  font-semibold hover:bg-clip-text hover:text-transparent hover:bg-gradient-to-r from-[#684EFB] to-[#2064FA]"
                            onClick={() => setShowAllAdvantage(false)}
                          >
                            Show less
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="sm:!mt-10 !mt-12" id="specifications">
                <h3 className="sm:!mb-6 !mb-3 text-2xl font-semibold text-textblack">
                  Specifications
                </h3>
                {/* <div className="text-black700" dangerouslySetInnerHTML={{ __html: details?.descriptions?.specification_description }}></div> */}
                <div className="flex flex-col">
                  {!showSpecificationContent && (
                    <div
                      className="!mb-0 [&>*]:!text-[#647087]"
                      dangerouslySetInnerHTML={{
                        __html:
                          details?.descriptions?.specification_description?.slice(
                            0,
                            400
                          ),
                      }}
                    ></div>
                  )}
                  {showSpecificationContent && (
                    <div
                      className="!mb-0 [&>*]:!text-[#647087]"
                      dangerouslySetInnerHTML={{
                        __html:
                          details?.descriptions?.specification_description,
                      }}
                    ></div>
                  )}
                  {details?.descriptions?.specification_description?.length >
                    400 && (
                    <a
                      className="text-blue-900 cursor-pointer mb-2 hover:bg-clip-text hover:text-transparent hover:bg-gradient-to-r from-[#684EFB] to-[#2064FA]"
                      onClick={() =>
                        setShowSpecificationContent(!showSpecificationContent)
                      }
                    >
                      {!showSpecificationContent ? "Read More" : "Read Less"}
                    </a>
                  )}
                </div>
                <div className="!border !border-grayLight/60 rounded-lg bg-[#F1F1F5] !mt-5">
                  {!showAllSpecification &&
                    details?.specifications?.length > 0 &&
                    details?.specifications.slice(0, 5).map((item, index) => (
                      <div
                        className={`${
                          index + 1 < details?.specifications?.length
                            ? "!border-b !border-grayLight/60"
                            : ""
                        } p-3 flex`}
                      >
                        <div className="font-semibold text-textblack text-sm w-4/12">
                          {item.type}
                        </div>
                        <div className="w-8/12 text-sm text-[#1A1A1A]">
                          {item.value}
                        </div>
                      </div>
                    ))}
                  {showAllSpecification &&
                    details?.specifications?.length > 0 &&
                    details?.specifications.map((item, index) => (
                      <div
                        className={`${
                          index + 1 < details?.specifications?.length
                            ? "!border-b !border-grayLight/60"
                            : ""
                        } p-3 flex`}
                      >
                        <div className="font-semibold text-textblack text-xs w-4/12">
                          {item.type}
                        </div>
                        <div className="w-8/12 text-xs text-[#1A1A1A]">
                          {item.value}
                        </div>
                      </div>
                    ))}
                </div>

                <div className="!mt-6 flex items-center">
                  <div className="w-6/12">
                    {details?.specifications?.length > 5 && (
                      <>
                        {!showAllSpecification && (
                          <div className="">
                            <button
                              className="text-blue-900 font-semibold hover:bg-clip-text hover:text-transparent hover:bg-gradient-to-r from-[#684EFB] to-[#2064FA]"
                              onClick={() => setShowAllSpecification(true)}
                            >
                              Show all {details?.specifications?.length}{" "}
                              Specifications
                            </button>
                          </div>
                        )}
                        {showAllSpecification && (
                          <div className="">
                            <button
                              className="text-blue-900 font-semibold hover:bg-clip-text hover:text-transparent hover:bg-gradient-to-r from-[#684EFB] to-[#2064FA]"
                              onClick={() => setShowAllSpecification(false)}
                            >
                              Show less
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  <div className="w-6/12">
                    <button
                      className="ml-auto bg-[#684EFB] text-white text-base rounded-lg w-max text-center font-semibold !py-2 !px-4 flex items-center justify-center shadow-sm	shadow-[#101828]/5 bg-gradient-to-r from-[#684EFB] to-[#2064FA] hover:from-[#2064FA] hover:to-[#3B37F5]"
                      onClick={() => setShowSitevisitModal(true)}
                    >
                      <span className="mr-2">
                        <UserIcon className=" stroke-white " />
                      </span>
                      Schedule Site Visit
                    </button>
                  </div>
                </div>
              </div>

              {details?.payment_plans?.length > 0 && (
                <div className="sm:!mt-10 !mt-12" id="paymentPlan">
                  <h3 className="sm:!mb-6 !mb-3 text-2xl font-semibold text-textblack">
                    Payment Plans
                  </h3>
                  <div className="space-y-4">
                    {details?.payment_plans.map((item, index) => (
                      <div className="border rounded-xl !p-4" key={item.uuid}>
                        <div className="flex items-start !gap-3">
                          <div className="w-7">
                            <BlueCheckIcon />
                          </div>
                          <div className="flex flex-col w-full gap-px">
                            <h4 className="text-base font-semibold">
                              {item.name}
                            </h4>
                            {item.description && (
                              <p className="mb-0 text-sm text-black700 font-medium">
                                {item.description}{" "}
                              </p>
                            )}
                            <p className="text-sm text-black700 font-medium m-0">
                              <span>Validity : </span>
                              {moment(item.validity).format("Do MMM YYYY")}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {details?.builder_info?.length > 0 && (
                <div className="sm:!mt-10 " id="about">
                  <h3 className="sm:!mb-6 !mb-3 text-2xl font-semibold capitalize text-textblack">
                    About {details?.name}
                  </h3>
                  <div>
                    <div className=" w-44 h-36 !border !border-grayLight rounded-lg">
                      <img
                        src={details?.builder_info[0]?.builder_logo}
                        alt=""
                        className="rounded-lg h-100 w-full object-contain"
                      />
                    </div>
                    {/* <div className="!mt-5" dangerouslySetInnerHTML={{ __html: details?.descriptions?.about_project_description }}></div> */}
                    <div className="flex flex-col mt-6">
                      {!showAboutContent && (
                        <div
                          className="!mb-0 [&>*]:!text-[#647087]"
                          dangerouslySetInnerHTML={{
                            __html:
                              details?.builder_info[0]?.builder_description?.slice(
                                0,
                                400
                              ),
                          }}
                        ></div>
                      )}
                      {showAboutContent && (
                        <div
                          className="!mb-0 [&>*]:!text-[#647087]"
                          dangerouslySetInnerHTML={{
                            __html:
                              details?.builder_info[0]?.builder_description,
                          }}
                        ></div>
                      )}
                      {details?.builder_info[0]?.builder_description?.length >
                        400 && (
                        <a
                          className="text-blue-900 font-semibold hover:bg-clip-text hover:text-transparent hover:bg-gradient-to-r from-[#684EFB] to-[#2064FA]"
                          onClick={() => setShowAboutContent(!showAboutContent)}
                        >
                          {!showAboutContent ? "Read More" : "Read Less"}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {details?.rera?.length > 0 && (
                <div className="sm:!mt-10 mt-12 ">
                  <div className="border rounded-xl shadow-bottomshadow">
                    <div className="p-3  bg-[#1A1A1A05] !border-b border-grayLight/60">
                      <div className=" text-textblack text-sm font-medium w-1/3">
                        Project Rera{" "}
                      </div>
                      {/* <div className="w-2/3 text-sm text-gray700 text-end ">Brokerage</div> */}
                    </div>
                    <div className="p-3 border-b flex">
                      {details.rera[0].rera_link && (
                        <div className=" text-black700 text-sm w-[76px] h-[76px] border rounded-lg mr-2.5">
                          <img
                            src={details.rera[0].rera_link}
                            className="!h-full !w-full"
                            alt=""
                          />
                        </div>
                      )}
                      <div className="w-2/3 text-sm text-gray700">
                        <span className="font-bold text-textblack">
                          {details?.name} :
                        </span>{" "}
                        {details?.rera?.map((i) => i.rera_no).join(", ")}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="w-[387px] !pr-2">
              <div className="sticky top-14">
                {userProfile.rm_name && (
                  <div className="border rounded-[10px] !p-5 shadow-boxshadow">
                    <h1 className="m-0 text-xl font-semibold">
                      Contact Our Real Estate Expert
                    </h1>
                    <div className="flex justify-between items-center !mt-5 w-full">
                      <div className="flex gap-2 w-[calc(100%-80px)]">
                        <div className="h-11 w-11 grow-0 shrink-0 basis-11 !border rounded-md border-grayLight overflow-hidden inline-flex items-center justify-center">
                          {getInitials(userProfile.rm_name || "-")}
                        </div>
                        <div className="w-[calc(100%-45px)] !pr-3">
                          <p className="m-0 font-semibold text-textblack !mb-2 truncate w-full">
                            {userProfile.rm_name || "-"}
                          </p>
                          <p className="m-0 text-xs text-black700">
                            Propacity SM
                          </p>
                        </div>
                      </div>
                      <div className="flex w-20 grow-0 shrink-0 basis-20">
                        <button className="!mr-4">
                          <TooltipText title={userProfile.rm_mobile}>
                            <PhoneIcon />
                          </TooltipText>
                        </button>
                        <a
                          className=""
                          href={`https://wa.me/${userProfile?.rm_mobile}`}
                          target="_blank"
                        >
                          <WhatsappIcon className="w-8 h-8" />
                        </a>
                      </div>
                    </div>
                  </div>
                )}
                {details?.offers?.length > 0 && (
                  <div
                    className="w-full h-[213px] rounded-xl shadow-boxshadow !mt-6 !py-4 !pl-4"
                    style={styles}
                  >
                    <div className="">
                      <RupeesIconYellow className="w-8 h-8" />
                    </div>
                    <p className="m-0 text-white text-xl font-bold">Benefits</p>
                    <div className="my-3">
                      <OfferImg />
                    </div>
                    <div className="space-x-4">
                      <Slider {...offer}>
                        {details?.offers.map((offer, max) => (
                          <div
                            className="rounded-xl !w-[200px] h-[92px] !mr-3 overflow-hidden relative cursor-pointer"
                            onClick={() => setShowSitevisitModal(true)}
                          >
                            <img src={offer.image_url} alt="" />
                            {/* <div className='bg-white !w-[206px] rounded-[10px] shadow-boxshadow !p-3 !mr-3 relative cursor-pointer' onClick={() => setShowSitevisitModal(true)}>
                                                        <img src={offer.image_url} alt="" />
                                                         <div className='absolute right-3 top-3'>
                                                            <RightIconCard />
                                                        </div>
                                                        <div className='m-0 text-[#684EFB] text-xs inline-flex items-center'>
                                                            <span className='font-bold mr-2 text-base text-black'>₹ {offer.amount}</span>
                                                            {offer.offer_type === 'Booking' && <span className='text-xs font-semibold bg-clip-text text-transparent bg-gradient-to-r from-[#684EFB] to-[#2064FA]'>Spot Booking</span>}
                                                            {offer.offer_type === 'Site visit' && <span className=' text-xs font-semibold bg-clip-text text-transparent bg-gradient-to-r from-[#684EFB] to-[#2064FA]'>Site visit</span>}
                                                        </div>
                                                        <p className=' flex text-xs text-black700 !mt-2 mb-0'>
                                                            <span><CalenderIcon className='h-4 w-4 mr-2' /></span> Valid till {moment(offer.validity).format('DD MMM YYYY')}
                                                        </p> */}
                          </div>
                        ))}
                      </Slider>
                    </div>
                  </div>
                )}
                <div
                  className="w-full h-[240px] rounded-xl !mt-6 !p-4 shadow-boxshadow !border border-grayLight/60"
                  style={{
                    backgroundImage: `url(${referBg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: `-534px -216px`,
                  }}
                >
                  <div className="flex justify-center">
                    <LeadsAvtar />
                  </div>
                  <p className="!m-0 text-center text-lg font-semibold !mt-5">
                    Add Leads
                  </p>
                  <p className="text-sm text-black700 text-center">
                    Add lead interested in the project to get brokerage from
                    Propacity
                  </p>
                  <button
                    className="bg-[#684EFB] text-white text-base rounded-lg w-full text-center font-semibold !py-2 flex items-center justify-center shadow-sm	shadow-[#101828]/5 bg-gradient-to-r from-[#684EFB] to-[#2064FA] hover:from-[#2064FA] hover:to-[#3B37F5]"
                    onClick={() => setShowSitevisitModal(true)}
                  >
                    <span className="mr-2">
                      <UserIcon className=" stroke-white " />
                    </span>
                    Schedule Site Visit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="sm:!mt-10 mt-12 !w-[90%] mx-auto">
            <div className="bg-[#E5EFFF] !py-6 !px-4 sm:!py-14 sm:!px-16 rounded-2xl">
              <div className="lg:flex lg:justify-between">
                <div>
                  <h3 className="md:text-3xl text-2xl text-textblack font-semibold !m-0 ">
                    Schedule a Site Visit Today
                  </h3>
                  <p className="md:text-xl !mb-0 text-md !mt-4 text-gray700 flex flex-col lg:flex-row">
                    <span className="mr-2.5">
                      <AvIcon />
                    </span>
                    20+ Clients Scheduled Sitevisit in the last 24 hrs.
                  </p>
                </div>
                <div className="mt-6 lg:mt-0">
                  <button
                    className="bg-[#684EFB] text-white text-base rounded-lg w-max text-center font-semibold !py-2 !px-4 flex items-center justify-center shadow-sm	shadow-[#101828]/5 bg-gradient-to-r from-[#684EFB] to-[#2064FA] hover:from-[#2064FA] hover:to-[#3B37F5]"
                    onClick={() => setShowSitevisitModal(true)}
                  >
                    <span className="mr-2">
                      <UserIcon className=" stroke-white " />
                    </span>
                    Schedule Site Visit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="!mt-12 md:px-0 px-4 ">
            <div className="flex items-center justify-center flex-col">
              <h3 className="text-2xl text-textblack sm:!mb-5 !mb-3 font-semibold">
                Frequently asked questions
              </h3>
              <p className="md:text-xl text-black700 mb-0">
                Everything you need to know about the product and billing.
              </p>
            </div>
            {/* <!-- hidden in mobile view --> */}
            <div className="mx-auto flex-col sm:w-[768px] sm:flex ">
              <div className="mt-[80px]">
                {!viewAll &&
                  details?.project_faq?.length > 0 &&
                  details.project_faq.map((fq, index) => {
                    return (
                      index < 3 && (
                        <div className="!border-b !border-grayLight pb-6  pt-6">
                          <div className="font-medium sm:text-lg text-textblack flex">
                            <span className="mr-1">Q:</span>
                            <span className="">{fq.question}</span>
                          </div>
                          <div className="flex !mt-2">
                            <span className="mr-1">A:</span>
                            <span
                              dangerouslySetInnerHTML={{ __html: fq.answer }}
                            ></span>
                          </div>
                        </div>
                      )
                    );
                  })}
                {viewAll &&
                  details?.project_faq?.length > 0 &&
                  details.project_faq.map((fq, index) => {
                    return (
                      <div className="!border-b !border-grayLight pb-6 !mt-6">
                        <div className="font-medium text-lg text-black">
                          <span className="mr-1">Q:</span>
                          <span className="">{fq.question}</span>
                        </div>
                        <div className="flex !mt-2">
                          <span className="mr-1">A:</span>
                          <span
                            dangerouslySetInnerHTML={{ __html: fq.answer }}
                          ></span>
                        </div>
                      </div>
                    );
                  })}
                {details?.project_faq?.length > 3 && (
                  <div className="flex items-cener justify-center my-8 ">
                    <button
                      className="del-btn-pr-hover !py-2 w-[130px] !px-4 !border !border-[#CFD5DE] rounded-lg text-black text-sm font-medium inline-flex items-center  focus:outline-0 justify-between bg-gradient-to-r  hover:from-[#2064FA] hover:to-[#3B37F5] hover:text-white"
                      onClick={() => setViewAll(!viewAll)}
                    >
                      {viewAll ? "View Less" : "View All"}
                      <DownIcon
                        className={`!ml-2 ${viewAll ? "rotate-180" : ""}`}
                      />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* {showLightModal && <LightGalleryModal show={showLightModal} closeModal={() => setShowLightModal(false)} style={style} media={details?.media} selectdImg={selectdImg} />} */}
        {showButton && (
          <a
            className={`${style.backtotop}`}
            onClick={() => scrollToSection("home")}
          >
            <BacktoTopIcon />
            Scroll To Top
          </a>
        )}
        {showLightModal && (
          <Lightbox
            open={showLightModal}
            close={() => setShowLightModal(false)}
            slides={media
              ?.filter((item) => item?.type !== "video/mp4")
              .map((item) => ({ src: item.url }))}
            carousel={{
              finite: true,
            }}
            index={selectdImg || 0}
            plugins={[Thumbnails]}
            // video={{
            //     controls: true,
            //     playsInline: true,
            //     autoPlay: false,
            //     loop: false,
            //     muted: true,
            //     disablePictureInPicture: false,
            //     disableRemotePlayback: false,
            //     controlsList: ["nodownload" | "nofullscreen" | "noremoteplayback"].join(" "),
            //     crossOrigin: '',
            //     preload: '',
            // }}
          />
        )}

        <AddYourListModal
          show={showAddToListModal}
          closeModal={() => setShowAddToListModal(false)}
          item={{ name: details.project?.name, uuid }}
          style={style}
          handleAddToList={handleAddToList}
        />
        <ContactModal
          show={showContactModal}
          closeModal={() => setShowContactModal(false)}
          item={{ name: details.project?.name, uuid }}
          style={style}
          handleContact={handleContact}
        />
        {showSiteVisitModal && userProfile?.is_owner (
          <ScheduleSiteVisitModal
            show={showSiteVisitModal}
            closeModal={() => setShowSitevisitModal(false)}
            uuid={uuid}
            redirectFrom="details"
          />
        )}
        {
          // showSiteVisitModal && <NewLeadModal show={showSiteVisitModal} closeModal={() => setShowSitevisitModal(false)} />
        }
        {/* {
                    showLeadSuccessModal && <LeadSubmitSuccess show={showLeadSuccessModal} closeModal={() => setShowLeadSuccessModal(false)} />
                } */}
        {
          // showLeadSuccessModal && <LeadSubmitFail show={showLeadSuccessModal} closeModal={() => setShowLeadSuccessModal(false)} />
        }
      </div>
    </div>
  );
};

export default ProjectDetail;
